import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Formik, Form } from 'formik';

import Modal from '../shared/Modal';
import InputText from '../shared/InputText';
import Button from '../shared/Button';
import Title from '../shared/Title';
import Text from '../shared/Text';
// import DebugData from '../shared/DebugData';

import { StyleGoalModal } from '../shared/resultsStyles';

const StyledGoalModal = styled.div`
  padding: 0px;
  display: flex;
  flex-direction: column;
`;

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`;

const StyledButton = css`
  box-shadow: 2px 2px 15px -3px rgba(0,0,0,0.25);
  height: 40px;
  margin-bottom: 20px;
`;

class GoalModal extends Component {
  state = { val: null };

  isInputEmpty = (props) => {
    const input = props.values.customGoal || '';
    return input.length === 0;
  }

  render() {
    const { show, onCreateGoal, onCloseModal } = this.props;
    return (
      <Modal
        show={show}
        onCloseModal={onCloseModal}
        styles={StyleGoalModal}
      >
        {({ closeModal }) => (
          <StyledGoalModal>
            <Title level={4} medium>¿Qué quieres lograr?</Title>
            <Formik
              onSubmit={(values, actions) => {
                onCreateGoal(values);
                closeModal();
                actions.setSubmitting(false);
              }}
            >
              {props => (
                <StyledForm>
                  <InputText
                    name="customGoal"
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    value={props.values.customGoal}
                    placeholder="Ingresa tu meta..."
                    pattern="(?i)^(?:(?![×Þß÷þø])[-'0-9a-zÀ-ÿ])+$"
                    autoComplete="off"
                  />
                  <Button
                    type="submit"
                    disabled={this.isInputEmpty(props)}
                    color={!this.isInputEmpty(props) ? 'default' : 'disabled'}
                    styles={StyledButton}
                  >
                    <Text type="buttonText" color="white" medium>
                        → Añadir meta
                    </Text>
                  </Button>
                  {/* <DebugData data={props} /> */}
                </StyledForm>
              )}
            </Formik>
          </StyledGoalModal>
        )}
      </Modal>
    );
  }
}

GoalModal.propTypes = {
  show: PropTypes.bool,
  onCreateGoal: PropTypes.func,
  onCloseModal: PropTypes.func,
};

GoalModal.defaultProps = {
  show: false,
  onCreateGoal: () => {},
  onCloseModal: () => {},
};

export default GoalModal;
